export function normalizeLeadPhone(value) {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.length === 10 ? `91${digits}` : digits;
}

export function phonesMatch(a, b) {
  const left = normalizeLeadPhone(a);
  const right = normalizeLeadPhone(b);
  return Boolean(left && right && left === right);
}

export function applyConversationUpdateToLeads(prevLeads, data, { reorder = true } = {}) {
  if (data?.last_message_direction !== 'incoming') return prevLeads;
  if (!Array.isArray(prevLeads) || prevLeads.length === 0) return prevLeads;

  const idx = prevLeads.findIndex(
    (lead) =>
      (data.lead_id != null && Number(lead?.id) === Number(data.lead_id)) ||
      phonesMatch(lead?.user?.phone_number, data.phone_number)
  );
  if (idx === -1) return prevLeads;

  const updated = {
    ...prevLeads[idx],
    last_whatsapp_message_at: data.last_message_at,
    unread_whatsapp_count: data.unread_count,
    last_whatsapp_preview: data.last_message_preview,
    last_whatsapp_direction: data.last_message_direction
  };

  if (!reorder) {
    const next = [...prevLeads];
    next[idx] = updated;
    return next;
  }

  const rest = [...prevLeads];
  rest.splice(idx, 1);
  return [updated, ...rest];
}

/** @deprecated Use applyConversationUpdateToLeads */
export function bumpLeadFromConversationUpdate(prevLeads, data) {
  return applyConversationUpdateToLeads(prevLeads, data, { reorder: true });
}

export function formatWhatsAppMessageTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  if (isToday) {
    return date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  }
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}
